"use client";

import React from 'react';
import { motion } from 'framer-motion';
import Image from 'next/image';

interface UseCase {
  title: string;
  description: string;
  image: string;
}

interface AlternatingUseCasesProps {
  title: string;
  useCases: UseCase[];
}

const AlternatingUseCases: React.FC<AlternatingUseCasesProps> = ({ title, useCases }) => {
  return (
    <section className="w-full my-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-16">{title}</h2>
        <div className="space-y-12 md:space-y-20 text-sm">
          {useCases.map((useCase, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
              style={{ willChange: "transform, opacity" }}
            >
              {/* Mobile Layout */}
              <div className="md:hidden">
                <div className="relative h-80 w-full overflow-hidden">
                  <Image
                    src={useCase.image}
                    alt={useCase.title}
                    fill
                    sizes="100vw"
                    className="z-0 object-cover"
                  />
                  <div className="absolute inset-0 bg-black/30"></div>
                  <div className="absolute inset-x-0 bottom-0 p-6 bg-black/20 backdrop-blur-md">
                    <h3 className="text-2xl font-bold mb-2 text-white">{useCase.title}</h3>
                    <p className="text-white/80">{useCase.description}</p>
                  </div>
                </div>
              </div>

              {/* Desktop Layout */}
              <div className={`hidden md:flex items-center gap-12 ${index % 2 === 1 ? 'flex-row-reverse' : 'flex-row'}`}>
                <div className="w-1/2">
                  <h3 className="text-2xl font-bold mb-4">{useCase.title}</h3>
                  <p className="text-white/70">{useCase.description}</p>
                </div>
                <div className="w-1/2 h-80 relative overflow-hidden">
                  <Image
                    src={useCase.image}
                    alt={useCase.title}
                    fill
                    sizes="50vw"
                    className="object-cover"
                  />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AlternatingUseCases;
